module.exports = __webpack_public_path__ + "static/media/ausl-romagna.0bf12744.jpg";